import { $, $$ } from 'utils/dom';
import RangeDatePicker from 'modules/datepicker/datepicker';

const datePickers = $$('[data-date]');
if (datePickers.length) {
  datePickers.forEach(datePicker => {
    const txtStart = $('[data-datetype="start"]', datePicker);
    const txtEnd = $('[data-datetype="end"]', datePicker);
    const hiddenDateInput = $('[data-date-hidden]', datePicker);
    const container = $('.ex-inputs-picker', datePicker);

    if (txtStart && txtEnd) {
      // range picker
      new RangeDatePicker({
        root: datePicker,
        txtStart,
        txtEnd,
        datepickerContainer: container,
        hiddenDateInput,
      }).init();
    }
  });
}

// fix for safari
// https://github.com/chrisdavies/tiny-date-picker/issues/92

const datepickerBoxes = $$('.ex-inputs-picker');
if (datepickerBoxes.length) {
  datepickerBoxes.forEach(datepickerBox => {
    datepickerBox.addEventListener('mousedown', evt => {
      evt.preventDefault();
      evt.stopPropagation();
      return false;
    });
  });
}
